module.exports = __webpack_public_path__ + "img/Pr19.bf4d7aa4.png";